<!--suppress XmlInvalidId, HtmlUnknownBooleanAttribute, TypeScriptUnresolvedVariable, AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>Settings</li>
  </ol>
</nav>
<div [hidden]="loading">
  <div class="my-2" translate>Account</div>
  <div class="row">
    <app-settings-button-widget [iconPath]="'assets/img/settings-icons/account-management.svg'" [title]="'Account Management'" [clickNav]="'/private/settings-update'"/>
    <app-settings-button-widget [iconPath]="'assets/img/settings-icons/bank-info.svg'" [title]="'Bank Information'" [clickNav]="'/private/bank-update'"/>
    <app-settings-button-widget [iconPath]="'assets/img/settings-icons/subscription-info.svg'" [title]="'Subscription Info'" [clickNav]="'/private/subscription-update'"/>
    <app-settings-button-widget [iconPath]="'assets/img/settings-icons/api-keys.svg'" [title]="'API Keys'" [clickNav]="'/private/api-keys'" />
    <app-settings-button-widget [iconPath]="'assets/img/settings-icons/request-update-account.svg'" [title]="'Request Update Account'" [clickNav]="'/private/request-update-account'" />
    <app-settings-button-widget [iconPath]="'assets/img/settings-icons/data-requests.svg'" [title]="'My Data Requests'" [clickNav]="'/private/data-requests'" />
    <app-settings-button-widget [iconPath]="'assets/img/settings-icons/privacy-consent.svg'" [title]="'Privacy & Consent'" [clickNav]="'/private/privacy-consent'" />
    <app-settings-button-widget [iconPath]="'assets/img/settings-icons/account-management.svg'" [title]="'Download my data'" [clickNav]="'/private/download-my-data'" />
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
